import { BaseSiteService, OccEndpointsService, CanonicalUrlOptions, CmsService, PageLinkService, PageMetaConfig, WindowRef } from '@spartacus/core';
import { Observable, of, filter, map, switchMap, withLatestFrom, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UrlMappingService } from './url-mapping.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPageLinkService extends PageLinkService {
  baseUrl?: string;

  constructor(
    protected pageMetaConfig: PageMetaConfig,
    protected winRef: WindowRef,
    private readonly occEndpointsService: OccEndpointsService,
    private readonly cmsService: CmsService,
    private readonly http: HttpClient,
    private readonly urlMappingService: UrlMappingService,
    private readonly baseSiteService: BaseSiteService
  ) {
    super(pageMetaConfig, winRef);
  }

  protected removeQueryParams(url: string, _config: CanonicalUrlOptions): string {
    const queryPos = url.indexOf('?');

    if (queryPos > -1) {
      const urlBeforeQueryParam = url.substr(0, queryPos);
      const params = new URLSearchParams(url.substr(queryPos));
      const newParams = new URLSearchParams();

      url = urlBeforeQueryParam;

      params.forEach((value, key) => {
        if (['bundle', 'page'].includes(key)) {
          newParams.append(key, value);
        }
      });

      if (newParams.toString().length > 0) {
        url = `${urlBeforeQueryParam}?${newParams.toString()}`;
      }
    }

    return url;
  }

  getTranslatedCanonicalUrl(options?: CanonicalUrlOptions, url?: string): Observable<string> {
    return this.cmsService.getCurrentPage().pipe(
      filter((p) => Boolean(p)),
      switchMap((page) =>
      {
        url = page.label === '/recipe/detail' ? this.winRef.location.href : url;
        return page.label === '/not-found' ? of(undefined) : this.getRealTranslatedCanonicalUrl(options, url);}
      )
    );
  }

  private getRealTranslatedCanonicalUrl(options?: CanonicalUrlOptions, url?: string): Observable<string> {
    const config: CanonicalUrlOptions = {
      ...this.pageMetaConfig?.pageMeta?.canonicalUrl,
      ...options
    };

    url = (url === '/') ? '' : url ?? this.winRef.location.href ?? '';

    if (url && url.startsWith('http')) {
      url = url.replace(this.winRef.location.origin, '');
    }

    return this.baseSiteService.get().pipe(
      map((baseSite) => baseSite.uid),
      withLatestFrom(this.urlMappingService.getUrlMappingByCode(url)),
      switchMap(([site, urlMapping]) => {
        if (urlMapping) {
          url = url.replace(urlMapping.code, urlMapping.value);
        }

        return this.getBaseUrl(site).pipe(
          map((baseUrl) => this.buildCanonicalUrl(baseUrl + url || this.winRef.location.href, config))
        );
      })
    );
  }

  private getBaseUrl(site: string): Observable<string> {
    const url: string = this.occEndpointsService.buildUrl('baseUrl', { urlParams: { site } });
    return this.baseUrl ? of(this.baseUrl) : this.http.get(url, { responseType: 'text' }).pipe(
      tap((baseUrl) => this.baseUrl = baseUrl)
    );
  }
}
